import PublicLayout from "@/components/layouts/bootstrap/PublicLayout";
import Link from "next/link";
import { useRouter } from "next/router";
import { Image } from 'react-bootstrap';

export default function Healthcare()
{
    const router = useRouter();
    return (
        <>
            <section className="hero-reseller healthcare-reseller d-flex align-items-center text-white">
                <div className="container hero-inner">
                    <div className="hero-copy d-inline-block">
                        <h1 className="publicBannerHeading">Healthcare & Community</h1>
                    </div>
                </div>
                <Link
                    className="btn btn-info text-white mt-3 float-end"
                    href="/industry_questions"
                >
                    VIEW EXPERT QUESTIONS
                </Link>
            </section>

            <section className="py-5 bg-white">
                <div className="container">
                    <div className="mb-4">
                        <button
                            onClick={() => router.back()}
                            className="button btn-purple me-3 text-uppercase border-0 p-2 px-3"
                        >
                            Back
                        </button>
                        <Link className="button btn-purple me-3" href="/contact">BOOK A DEMO</Link>
                        <Link className="button btn-purple me-3" href="/register">REGISTER</Link>
                        <Link className="button btn-purple me-3" href="/pricing">PRICING</Link>
                        <Link className="button btn-purple me-3" href="/register">TRY A FREE POLL</Link>

                        <Link className="button btn-purple" href="/faq">FAQ</Link>
                    </div>
                    <div className="row align-items-center">

                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <h2 className="fw-bold mb-4 publicTextNew">
                                Real-time feedback that <br />builds trust and improves care.
                            </h2>
                            <p className="text-muted mb-3">
                                In <b>healthcare</b> and community services, understanding people’s needs isn’t optional—it’s essential. But traditional <b>patient satisfaction surveys</b> and post-program feedback rarely capture how patients, clients, or staff feel in the moment.
                            </p>
                            <p className="text-muted mb-3">
                                Instant Polls helps organisations listen, respond, and improve—in real time. Whether you’re leading a<b> hospital briefing</b>, a <b>wellness workshop</b>, or a community outreach program, it allows you to capture <b>stakeholder feedback</b> as it happens. This enables you to act with empathy and clarity when it matters most, improving <b>patient engagement</b> and trust.                            </p>
                            <p className="text-muted mb-3">
                                Because better questions lead to better care—and better <b>clinical outcomes</b>.
                            </p>
                        </div>
                        <div className="col-lg-6 text-center">
                            <Image src="/industry/healthcare-patient-polling.png" alt="healthcare patient feedback polling tool" className="img-fluid" />
                        </div>
                    </div>
                </div>
            </section>

            <section className="py-5 bg-blue">
                <div className="container text-center">
                    <div className="row g-5">
                        <div className="col-md-6 col-lg-4">
                            <div className="card border-0 h-100 bg-unset">
                                <div className="card-body">
                                    <h5 className="card-title bu-semibold mb-3 text-start">The Challenge</h5>
                                    <p className="card-text text-muted">
                                        <b>Healthcare</b> and community organisations rely on consistent feedback to drive <b>quality improvement</b> and better health outcomes. Yet most feedback systems are slow, outdated, and disconnected from the moments that truly matter—when patients, staff, or participants are actively engaged in care.</p>
                                    <p className="card-text text-muted">
                                        By the time traditional <b>patient survey</b> results arrive, the opportunity to make meaningful, systemic change has passed. <b>Frontline leaders</b> and clinicians need a faster, more transparent way to measure <b>patient sentiment</b>, build trust, and act on <b>real-time patient feedback</b> before the clinical encounter fades. Without<b> instant insights,</b> organisations struggle to maintain the agility required for modern, patient-centered care.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 col-lg-4">
                            <div className="card border-0 h-100 bg-unset">
                                <div className="card-body">
                                    <h5 className="card-title bu-semibold mb-3 text-start">The Solution</h5>
                                    <p className="card-text text-muted">
                                        Instant Polls empowers <b>healthcare professionals</b> and community leaders to gather <b>patient and staff feedback</b> in seconds. Our <b>accessible feedback tools</b> can be launched instantly during <b>clinical training sessions</b>, staff briefings, or live community events, with results displayed in real time to foster a culture of transparency and <b>open engagement</b>.                                    </p>
                                    <p className="card-text text-muted"> It’s fast, flexible, and specifically designed for high-pressure care environments where understanding <b>patient needs</b> quickly and accurately can drive better <b>clinical outcomes</b>.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 col-lg-4">
                            <div className="card border-0 h-100 bg-unset">
                                <div className="card-body">
                                    <h5 className="card-title bu-semibold mb-3 text-start">The Result</h5>
                                    <p className="card-text text-muted">
                                        From <b>hospital networks</b> and national health departments to local support organisations, Instant Polls helps turn <b>patient and staff feedback</b> into immediate action.                                    </p>
                                    <p className="card-text text-muted">
                                        It creates stronger <b>team alignment</b> between frontline staff and <b>healthcare leadership</b>, improves <b>community engagement</b>, and helps every team deliver care with confidence and compassion. By capturing <b>real-time insights</b>, you ensure that your<b> community-led initiatives</b> are truly responsive to those they serve.                                    </p>
                                    <p className="card-text text-muted">
                                        Because when people feel heard in the moment, they feel cared for long after—improving the overall<b> patient experience</b> and building long-term trust.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section >

            <section className="features py-5">
                <div className="container">
                    <h2 className="text-center fw-bold mb-4 highlightedColor">How Instant Polls Works</h2>

                    <div className="row g-4">
                        <div className="col-12 col-md-6 col-lg-4">
                            <div className="rfeature-card d-flex">
                                <div className="rfeature-icon">
                                    <Image src="/industry/icons/dashboard.png" alt="polls analytics dashboard icon" className="img-fluid" />
                                </div>
                                <div>
                                    <div className="rfeature-title">Real-Time Dashboards</div>
                                    <p className="rfeature-text">Result stream in live, no refresh required.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-6 col-lg-4">
                            <div className="rfeature-card d-flex">
                                <div className="rfeature-icon">
                                    <Image src="/industry/icons/artificial-intelligence.png" alt="AI-powered polling intelligence icon" className="img-fluid" />
                                </div>
                                <div>
                                    <div className="rfeature-title">AI-Powered Sentiment</div>
                                    <p className="rfeature-text">Understand tone and context, not just raw numbers.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-6 col-lg-4">
                            <div className="rfeature-card d-flex">
                                <div className="rfeature-icon">
                                    <Image src="/industry/icons/segmentation.png" alt="audience segmentation icon" className="img-fluid" />
                                </div>
                                <div>
                                    <div className="rfeature-title">Segmentation</div>
                                    <p className="rfeature-text">Break results down by department, region, or demographics.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-6 col-lg-4">
                            <div className="rfeature-card d-flex">
                                <div className="rfeature-icon">
                                    <Image src="/industry/icons/system.png" alt="system integration icon" className="img-fluid" />
                                </div>
                                <div>
                                    <div className="rfeature-title">Seamless Integration</div>
                                    <p className="rfeature-text">Works with Microsoft Teams, Slack, CRMs, and more.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-6 col-lg-4">
                            <div className="rfeature-card d-flex">
                                <div className="rfeature-icon">
                                    <Image src="/industry/icons/cyber-security-icon.png" alt="data security and privacy icon" className="img-fluid" />
                                </div>
                                <div>
                                    <div className="rfeature-title">Enterprise-Grade Security</div>
                                    <p className="rfeature-text">Anonymous by default, encrypted end-to-end</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-6 col-lg-4">
                            <div className="rfeature-card d-flex">
                                <div className="rfeature-icon">
                                    <Image src="/industry/icons/outline.png" alt="reporting and insights icon" className="img-fluid" />
                                </div>
                                <div>
                                    <div className="rfeature-title">White-Label Branding</div>
                                    <p className="rfeature-text">Brand every poll as your own.</p>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </section>

            <section className="py-5 publicNewBgvColor">
                <div className="container testimonials">
                    <h2 className="mb-5 text-purple">Hear From Our Users</h2>
                    <div className="row g-4">
                        <div className="col-md-4">
                            <div className="bs-quotes">
                                <p>“Instant Polls changed how we run leadership meetings. We get clarity in minutes instead of waiting on surveys.”</p>
                                <cite>Managing Director, Professional Services</cite>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="bs-quotes">
                                <p>“As an event organiser, I finally have live engagement metrics to show sponsors real ROI.”</p>
                                <cite>Event Manager</cite>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="bs-quotes">
                                <p>“Our students love it. Real-time feedback makes learning more interactive.”</p>
                                <cite>University Lecturer</cite>
                            </div>
                        </div>
                    </div>
                </div>
            </section >

            <section className="lead-section-consulting d-flex align-items-center">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 py-5">
                            <h3 className="fw-bold mb-3 publicPageNewTextColor" >Improve care through <br />real-time understanding.</h3>
                            <p className="text-muted mb-3 text-dark">
                                Discover how Instant Polls can help your organisation capture <b>authentic feedback</b>, strengthen trust, and improve<b> service delivery</b>—all in real time. Whether you’re engaging patients, frontline staff, or diverse communities, Instant Polls gives you the clarity to act quickly, the transparency to build confidence, and the <b>data-driven insight</b> to keep improving care.
                            </p>
                            <Link href="/contact" className="btn btn-purple rounded-pill px-4 py-2" >BOOK A DEMO</Link>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

Healthcare.getLayout = (page) => <PublicLayout>{page}</PublicLayout>;
